<template>
  <div class="ele-body">
    <el-card shadow="never">
      <el-form
        :model="where"
        label-width="77px"
        class="ele-form-search"
        @keyup.enter.native="reload"
        @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :lg="6" :md="12">
            <el-form-item label="上游名称">
              <el-select clearable filterable class="ele-block" v-model="where.id" placeholder="请选择">
                <el-option v-for="item in upList" :key="item.id" :value="item.id" :label="item.upName" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="24">
            <el-form-item label="选择时间">
              <div class="recon-time-wrap">
                <el-radio-group v-model="timeQuick" size="small" @change="onTimeQuickChange">
                  <el-radio-button label="today">今日</el-radio-button>
                  <el-radio-button label="yesterday">昨日</el-radio-button>
                  <el-radio-button label="week">本周</el-radio-button>
                  <el-radio-button label="month">本月</el-radio-button>
                  <el-radio-button label="lastMonth">上月</el-radio-button>
                  <el-radio-button label="days30">30日</el-radio-button>
                </el-radio-group>
                <el-date-picker
                  v-model="where.time"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  @change="onTimePickerChange" />
              </div>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <div class="ele-form-actions">
              <el-button type="primary" icon="el-icon-search" class="ele-btn-icon" @click="reload">查询</el-button>
              <el-button @click="reset">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <div class="recon-stat-bar">
        <span>成功条数(收): {{ dataList.in_count }}</span>
        <span>金额(收): {{ dataList.in_amount }}</span>
        <span>实际费率(收): {{ dataList.in_fees }}</span>
        <span>成功条数(付): {{ dataList.out_count }}</span>
        <span>金额(付): {{ dataList.out_amount }}</span>
        <span>实际费率(付): {{ dataList.out_fees }}</span>
        <span>结余: {{ dataList.yingli }}</span>
      </div>

      <ele-pro-table
        ref="table"
        :where="where"
        :datasource="url"
        :columns="columns"
        :need-page="false"
        height="calc(100vh - 360px)" />
    </el-card>
  </div>
</template>

<script>
import reconTime from '@/mixins/recon-time';

const EMPTY_STATS = {
  in_count: 0,
  in_amount: '0.00',
  in_fees: '0.00',
  out_count: 0,
  out_amount: '0.00',
  out_fees: '0.00',
  yingli: '0.00'
};

export default {
  name: 'UplistRecon',
  mixins: [reconTime],
  data() {
    return {
      url: '/Reconciliation/uplist',
      columns: [
        { prop: 'upName', label: '上游名称', minWidth: 120, align: 'center', showOverflowTooltip: true },
        { prop: 'in_count', label: '成功条数(收)', minWidth: 110, align: 'center', showOverflowTooltip: true },
        { prop: 'in_paymentAmount', label: '金额(收)', minWidth: 110, align: 'center', showOverflowTooltip: true },
        { prop: 'in_jc_fees', label: '基础费率(收)', minWidth: 110, align: 'center', showOverflowTooltip: true },
        { prop: 'in_sj_fees', label: '实际费率(收)', minWidth: 110, align: 'center', showOverflowTooltip: true },
        { prop: 'out_count', label: '成功条数(付)', minWidth: 110, align: 'center', showOverflowTooltip: true },
        { prop: 'out_paymentAmount', label: '金额(付)', minWidth: 110, align: 'center', showOverflowTooltip: true },
        { prop: 'out_jc_fees', label: '基础费率(付)', minWidth: 110, align: 'center', showOverflowTooltip: true },
        { prop: 'out_sj_fees', label: '实际费率(付)', minWidth: 110, align: 'center', showOverflowTooltip: true },
        { prop: 'sj_Amount', label: '实际余额', minWidth: 110, align: 'center', showOverflowTooltip: true }
      ],
      where: { id: undefined, time: null },
      upList: [],
      dataList: { ...EMPTY_STATS }
    };
  },
  mounted() {
    this.queryUplist();
    this.loadStats();
  },
  methods: {
    reload() {
      this.$refs.table && this.$refs.table.reload({ where: this.where });
      this.loadStats();
    },
    reset() {
      this.where = { id: undefined, time: null };
      this.applyTimeQuick('today', true);
    },
    loadStats() {
      this.$http
        .post('/Reconciliation/getInorderCount', this.where)
        .then((res) => {
          if (res.data.code === 0) {
            this.dataList = { ...EMPTY_STATS, ...(res.data.data || {}) };
            return;
          }
          this.dataList = { ...EMPTY_STATS };
          this.$message.error(res.data.msg);
        })
        .catch((e) => {
          this.dataList = { ...EMPTY_STATS };
          this.$message.error(e.message);
        });
    },
    queryUplist() {
      this.$http
        .get('/Uplist/getupList')
        .then((res) => {
          if (res.data.code === 0) {
            this.upList = res.data.data || [];
            return;
          }
          this.$message.error(res.data.msg);
        })
        .catch((e) => {
          this.$message.error(e.message);
        });
    }
  }
};
</script>

<style scoped src="@/styles/recon-stat.css"></style>
